t = require('views/internal/teacup-with-helpers')('take_photo')

module.exports = ->
  t.video { class: 'video' + t.mustacheBlockInverted('connected', (-> ' hide')), autoplay: true, style: 'width:100%' }

  t.mustacheBlock 'error', ->
    t.p '.error', ->
      t.text t.mustacheVar('error')

  t.mustacheBlock 'connected', ->
    t.button '.primary.wide.js-snap', ->
      t.format 'snap-photo'

  t.mustacheBlockInverted 'connected', ->

    t.mustacheBlock 'error', ->
      t.p ->
        t.format 'couldnt-find-a-camera-to-connect-to-ellipsis'

    t.mustacheBlockInverted 'error', ->
      t.p ->
        t.format 'trying-to-access-your-computers-camera-ellipsis-check-the-banner-at-the-top-of-the-page'

    t.p '.u-bottom', ->
      t.a '.quiet-button.js-connect-camera', { href: '#' }, ->
        t.format 'try-again'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/take_photo.coffee